"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("@phishtool/ui");
const react_router_dom_1 = require("react-router-dom");
const portal_buttons_1 = __importDefault(require("./portal-buttons"));
const access_form_1 = __importDefault(require("./access-form"));
const header_1 = require("./header");
const EnterpriseQuotePortal = () => {
    const [quotePortal, setQuotePortal] = (0, react_1.useState)(null);
    const location = (0, react_router_dom_1.useLocation)();
    const match = location.pathname.match(/enterprise-quote-portal\/([^/]*)/);
    const token = (match === null || match === void 0 ? void 0 : match[1]) || '';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_1.Header, { quotePortal: quotePortal }), (0, jsx_runtime_1.jsx)(ui_1.Grid, { children: (0, jsx_runtime_1.jsx)(ui_1.Cell, { children: quotePortal ? ((0, jsx_runtime_1.jsx)(portal_buttons_1.default, { quotePortal: quotePortal })) : ((0, jsx_runtime_1.jsx)(access_form_1.default, { token: token, setQuotePortal: setQuotePortal })) }) })] }));
};
exports.default = EnterpriseQuotePortal;
